<template>
  <span v-if="value != null">
    <dt class="fs-14">{{label}} : </dt>
    <dd class="fs-14">{{value}}</dd>
  </span>
</template>
<script>
export default {
  name: 'technical-sheet-line',
	props: {
    data : {
      type: Object,
      default: null,
    }
	},
  data() {
    return {

    };
  },
  components: { },
  watch : { },
	methods: { },
	computed: {
    language () {
      return this.$i18n.locale;
    },
    label () {
      return _.get(this.data, `label.label.${this.language}`);
    },
    value () {
      const value =  _.trim(_.get(this.data, `value.value.${this.language}`));
      return value != '' ? value : null;
    }
	}
}
</script>
<style lang="scss" scoped>

dd {
  margin: 0px;
}

</style>
